import React, { useState } from "react";
import styles from "./experience.module.css";
import { Paper } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import Figure from "react-bootstrap/Figure";
import MeraBills from "./Merabills.jpg";
import Icrisat from "./icrisat.png";
import Jumbo from "./jumbo.jpg";
import Tufts from "./tufts.jpg";

function Experience() {
  return (
    <Paper>
      <section class="experience">
        <h2>Work Experience</h2>
        <ul>
          <Grid container justify="center" alignItems="center" direction="row">
            <Grid item xs={4}>
              <Figure>
                <Figure.Image
                  width={200}
                  height={200}
                  alt="171x180"
                  src={MeraBills}
                />
              </Figure>
            </Grid>

            <Grid item xs={8}>
              <li>
                <header>
                  <p className={styles.job_title}>
                    {" "}
                    <strong>Software Engineering Intern, MeraBills</strong>{" "}
                    &nbsp;&nbsp; &nbsp;&nbsp; 2020-Present{" "}
                  </p>
                </header>
                <ul>
                  <li>
                    Worked on MeraBills, a financial app aimed at connecting
                    microentrepreneurs with NGOs and Financial institutions.
                  </li>
                  <li>
                    Developed an Android charting UI to display cloud-synced
                    business reports to users.
                  </li>
                  <li>
                    Implemented a feature allowing users to subscribe to
                    customizable push notifications.
                  </li>
                  <li>
                    Currently working on collecting and visualizing user
                    analytics data using Firebase and BigQuery.
                  </li>
                </ul>
              </li>
              <br></br>
            </Grid>

            <Grid item xs={4}>
              <Figure>
                <Figure.Image
                  width={200}
                  height={200}
                  alt="160x180"
                  src={Jumbo}
                />
              </Figure>
            </Grid>

            <Grid item xs={8}>
              <li>
                <header>
                  <p className={styles.job_title}>
                    {" "}
                    <strong>Software Developer Jumbo Code</strong> &nbsp;&nbsp;
                    &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                    2020-Present{" "}
                  </p>
                </header>
                <ul>
                  <li>
                    Created the Tufts Class Matcher, a website (under
                    development) which aims to match students with similar
                    classes.
                  </li>
                  <li>
                    Built and am currently managing a team of 5 students to
                    build the React frontend and Node.js + SQL backend
                  </li>
                  <li>
                    Wrote the matching algorithm using SQL queries, eliminating
                    the need to load data into memory.
                  </li>
                </ul>
              </li>
              <br></br>
            </Grid>
            <br></br>

            <Grid item xs={4}>
              <Figure>
                <Figure.Image
                  width={200}
                  height={200}
                  src={Icrisat}
                  alt="171x180"
                />
              </Figure>
            </Grid>

            <Grid item xs={8}>
              <li>
                <header>
                  <p className={styles.job_title}>
                    {" "}
                    <strong>Research Intern, ICRISAT</strong> &nbsp;&nbsp;
                    &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                    &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2020-Present{" "}
                  </p>
                </header>
                <ul>
                  <li>
                    Interned under Dr.Mazumdar for his paper regarding the rate
                    of rancidity of different strains of Pearl Millet.
                  </li>
                  <li>
                    Learnt about best practice data storage methods and when to
                    use a DBMS vs a spread sheet system.
                  </li>
                  <li>
                    Implemented statistical methods such as (Chi-square, ANOVA,
                    Regression Modelling, KL divergence).
                  </li>
                </ul>
              </li>
              <br></br>
            </Grid>
          </Grid>
        </ul>

        <h2>Education, Leadership and Honors</h2>

        <Grid container justify="center" alignItems="center" direction="row">
          <Grid item xs={4}>
            <Figure>
              <Figure.Image className={styles.tufts}
                width={200}
                height={200}
                src={Tufts}
                alt="171x180"
              />
            </Figure>
          </Grid>

          <Grid item xs={8}>
            <header>
              <p className={styles.job_title}>
                {" "}
                <strong>Tufts University, GPA:3.93</strong> &nbsp;&nbsp;
                &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                2019-Present{" "}
              </p>
            </header>
            <p className={styles.coursework}>
              <strong>Relevant Coursework: </strong>Introduction to CS, Data
              Structures, Discrete Math, Calculus. (In progress) Intro to AI,
              Database systems, Algorithms. (Spring 2021) Machine Structures,
              Programming languages, intro to machine learning.
            </p>
            <p className={styles.coursework}>
              <strong>Honors:</strong> 35 ACT, 790 SAT math 2, 790 SAT biology,Presidents Gold Seal for Academic Excellence.
            </p>
            <p className={styles.coursework}>
              <strong>Leadership:</strong> Vice president and Speaker Coordinator TEDx@ISH, Student Council President ISH, Tufts BEATS VP.
            </p>
          </Grid>

          
        </Grid>
      </section>
    </Paper>
  );
}

export default Experience;
